import axios from 'axios'

export const refreshPageMixin = {
  data() {
    return {
      currentHash: '{{POST_BUILD_ENTERS_HASH_HERE}}',
      hashChanged: false,
      newHash: ''
    }
  },
  mounted() {
    // console.log('mounted ' + this.currentHash)
    this.checkVersion('/version.json')
    this.initVersionCheck('/version.json')
  },
  methods: {
    initVersionCheck(url, frequency = 1000 * 60 * 2) {
      // console.log('initVersionCheck ' + this.currentHash)
      setInterval(() => {
        this.checkVersion(url)
      }, frequency)
    },
    async checkVersion(url) {
      try {
        url = document.location.protocol + '//' + document.location.host + url

        const fileResponse = await axios.create({
          // baseURL: `${this.$root.url}`,
          headers: {
            'Content-type': 'application/json'
          }
        }).get(url + '?t=' + new Date().getTime())
        // debugger
        this.newHash = fileResponse.data.hash

        this.hashChanged = this.hasHashChanged(this.currentHash, this.newHash)
      } catch (error) {
        this.loading = false
        if (!error.response) {
          this.errorStatus = 'Error: Network Error'
        } else {
          this.errorStatus = error.response.data.message
        }
      }
    },
    hasHashChanged(currentHash, newHash) {
      // console.log('hasHashChanged ' + currentHash)
      // debugger
      /*
      if (!currentHash || currentHash === '{{POST_BUILD_EN' + 'TERS_HASH_HERE}}') {
        return true
      }
      */
      return currentHash !== newHash
    },
    reloadApp() {
      this.currentHash = this.newHash
      window.location.reload()
    }
  }
}
